import { collectNumbers, numericExtent, pivotStandardSeries } from "../utils";
const PIVOT_TYPES = ["standard", "fibonacci", "camarilla", "woodie", "demark"];
const PivotStandard = {
    name: "PivotStandard",
    compute: (bars, pivotType = 0) => {
        const typeStr = PIVOT_TYPES[pivotType] || "standard";
        return pivotStandardSeries(bars, typeStr);
    },
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default PivotStandard;
